import { gql, TypedDocumentNode } from "@apollo/client";

import { AiIntegration, MutationAiIntegrationUpdateArgs } from "types/generated";

export const UPDATE_AI_INTEGRATION: TypedDocumentNode<
  {
    aiIntegrationUpdate: Pick<AiIntegration, "id">;
  },
  MutationAiIntegrationUpdateArgs
> = gql`
  mutation UpdateAiIntegration(
    $id: ID!
    $name: String!
    $description: String
    $labels: [String!]!
    $provider: String!
    $model: String!
    $apiKey: String
    $space: ID
  ) {
    aiIntegrationUpdate(
      id: $id
      name: $name
      description: $description
      labels: $labels
      provider: $provider
      model: $model
      apiKey: $apiKey
      space: $space
    ) {
      id
    }
  }
`;
